import { useQueryClient } from 'react-query';

const useInvalidateCompetition = (competitionId) => {
  const queryClient = useQueryClient();

  return () => {
    const keys = [
      'competition',
      ['competitionSubmissions', competitionId],
      ['competitionProblems', competitionId],
    ];

    // Invalidate queries first (marks them stale but doesn't trigger immediate refetch)
    keys.forEach((key) => queryClient.invalidateQueries(key));

    // Immediately refetch, but only once to prevent infinite calls
    keys.forEach((key) => queryClient.refetchQueries(key, { cancelRefetch: false }));

    // Handle 'competitionLeaderboard' variations safely
    queryClient.invalidateQueries({
      predicate: (query) => query.queryKey[0] === 'competitionLeaderboard'
        && query.queryKey[1] === competitionId,
    });

    queryClient.refetchQueries({
      predicate: (query) => query.queryKey[0] === 'competitionLeaderboard'
        && query.queryKey[1] === competitionId,
    });
  };
};

export default useInvalidateCompetition;
